module.exports = __webpack_public_path__ + "static/media/p7.dd5512c1.svg";